import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { getLastNDaysRange, fmtDateTime } from "@/lib/time";
import { useAdminViewModel } from "@/pages/dashboard/admin/AdminViewModelContext";

export function PunchCorrectionsView() {
  const {
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    correctionStats,
    correctionStatsLoading,
  } = useAdminViewModel();

  return (
    <div className="mt-4 grid grid-cols-1 gap-4 [&>*]:min-w-0">
      <div className="flex flex-wrap items-end gap-2">
        <div className="flex gap-1">
          <Button
            size="sm"
            variant="outline"
            onClick={() => {
              const r = getLastNDaysRange(7);
              setFromDate(r.from);
              setToDate(r.to);
            }}
          >
            Week
          </Button>
          <Button
            size="sm"
            variant="outline"
            onClick={() => {
              const r = getLastNDaysRange(30);
              setFromDate(r.from);
              setToDate(r.to);
            }}
          >
            Month
          </Button>
        </div>
        <Input
          className="min-w-[160px] w-[160px]"
          type="date"
          value={fromDate}
          onChange={(event) => setFromDate(event.target.value)}
        />
        <Input
          className="min-w-[160px] w-[160px]"
          type="date"
          value={toDate}
          onChange={(event) => setToDate(event.target.value)}
        />
      </div>
                <Card>
                  <CardHeader>
                    <CardTitle>Punch corrections</CardTitle>
                    <CardDescription>
                      {correctionStatsLoading
                        ? "Loading..."
                        : `${correctionStats?.total ?? 0} correction(s) in this range`}
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    {correctionStatsLoading ? null : !correctionStats || correctionStats.total === 0 ? (
                      <p className="text-sm text-muted-foreground">No corrections in this range.</p>
                    ) : (
                      <div className="space-y-4">
                        <div className="grid gap-4 sm:grid-cols-3">
                          <div>
                            <div className="mb-1 text-xs font-medium text-muted-foreground">By employee</div>
                            <ul className="space-y-0.5 text-sm">
                              {correctionStats.by_subject.map((row) => (
                                <li key={`subj-${row.user_id}`} className="flex justify-between gap-2">
                                  <span className="truncate">{row.name}</span>
                                  <span className="tabular-nums text-muted-foreground">{row.count}</span>
                                </li>
                              ))}
                            </ul>
                          </div>
                          <div>
                            <div className="mb-1 text-xs font-medium text-muted-foreground">By editor</div>
                            <ul className="space-y-0.5 text-sm">
                              {correctionStats.by_actor.map((row) => (
                                <li key={`actor-${row.user_id}`} className="flex justify-between gap-2">
                                  <span className="truncate">{row.name}</span>
                                  <span className="tabular-nums text-muted-foreground">{row.count}</span>
                                </li>
                              ))}
                            </ul>
                          </div>
                          <div>
                            <div className="mb-1 text-xs font-medium text-muted-foreground">By field</div>
                            <ul className="space-y-0.5 text-sm">
                              {correctionStats.by_field.map((row) => (
                                <li key={`field-${row.changed_field}`} className="flex justify-between gap-2">
                                  <span className="truncate">{row.changed_field}</span>
                                  <span className="tabular-nums text-muted-foreground">{row.count}</span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                        <div className="overflow-x-auto">
                          <Table>
                            <TableHeader>
                              <TableRow>
                                <TableHead>When</TableHead>
                                <TableHead>Employee</TableHead>
                                <TableHead>Editor</TableHead>
                                <TableHead>Field</TableHead>
                                <TableHead>Change</TableHead>
                              </TableRow>
                            </TableHeader>
                            <TableBody>
                              {correctionStats.recent.map((row, idx) => (
                                <TableRow key={`${row.altered_at}-${row.subject_user_id}-${row.changed_field}-${idx}`}>
                                  <TableCell className="whitespace-nowrap">{fmtDateTime(row.altered_at)}</TableCell>
                                  <TableCell className="whitespace-nowrap">{row.subject_name}</TableCell>
                                  <TableCell className="whitespace-nowrap">{row.actor_name}</TableCell>
                                  <TableCell className="whitespace-nowrap">{row.changed_field}</TableCell>
                                  <TableCell className="whitespace-nowrap">
                                    {row.old_value} → {row.new_value}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </div>
                      </div>
                    )}
                  </CardContent>
                </Card>
    </div>
  );
}
